import { parse, isValid, parseISO } from "date-fns";

export const parseUKDate = (input) => {
  if (!input) return null;

  if (String(input).includes("T")) {
    const iso = parseISO(input);
    return isValid(iso) ? input : null;
  }

  const parsed = parse(input, "dd-MM-yyyy", new Date());

  return isValid(parsed) ? parsed.toISOString() : null;
};